import { ApolloError, FetchResult, useMutation } from '@apollo/client'
import { TAKE_OVER_MEETING } from '../MeetingMutations'
import { MEETINGS_BY_MANAGER } from '../meeting.graphql'
import { TakeOverMutation } from '../../../types'

export const useReviewerToTakeOverMeeting = (): {
  employeeTakeOverMeeting: (meetingId: number, managerId: number) => Promise<FetchResult<TakeOverMutation>>
  loading: boolean
  error: ApolloError | undefined
} => {
  const [takeOverMeeting, { loading, error }] = useMutation(TAKE_OVER_MEETING)
  const employeeTakeOverMeeting = (meetingId: number, managerId: number): Promise<FetchResult<TakeOverMutation>> => {
    return takeOverMeeting({
      variables: {
        meetingId: meetingId,
      },
      refetchQueries: [
        {
          query: MEETINGS_BY_MANAGER,
          variables: {
            managerId: managerId,
          },
        },
      ],
    })
  }

  return { employeeTakeOverMeeting, loading, error }
}
